import * as Sentry from '@sentry/react'

let initialized = false

export function initSentry() {
  if (initialized) return
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return
  Sentry.init({
    dsn,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  })
  initialized = true
}

export function captureException(err: unknown) {
  if (initialized) Sentry.captureException(err)
  else console.error(err)
}
